import { Component, OnInit, ViewChild } from '@angular/core';
import { AppInformationService, ArkUnitOfWork, AuthService, UtilityService } from 'app/core/core.module';
import { AuctionItem, AuctionPaddleUser, AuctionPurchase, Person } from 'app/core/model/entity-model';
import { DxDataGridComponent } from 'devextreme-angular';
import { confirm } from 'devextreme/ui/dialog';
import _ from 'lodash';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AuctionItemDialogComponent } from '../auction-item-dialog/auction-item-dialog.component';
import { AuctionPurchaseDialogComponent } from '../auction-purchase-dialog/auction-purchase-dialog.component';
import { PaddleDialogComponent } from '../paddle-dialog/paddle-dialog.component';

@Component({
    selector: 'app-purchase-overview',
    templateUrl: './purchase-overview.component.html',
    styleUrls: ['./purchase-overview.component.scss'],
})
export class PurchaseOverviewComponent implements OnInit {
    auctionPurchases: AuctionPurchase[];
    auctionPaddleInfos: any[] = [];

    auctionItems: any[] = [];
    people: Person[];
    auctionItemTypes = ['Live', 'Silent', 'Raffle Line'];

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    @ViewChild('itemDataGrid') itemDataGrid: DxDataGridComponent;

    constructor(private uow: ArkUnitOfWork, private auth: AuthService, private modalService: BsModalService, public appInfo: AppInformationService) {}

    async ngOnInit() {
        const people = (await this.uow.people.all(null, 'family')) as Person[];
        this.people = _.orderBy(
            people.filter((person) => !person.deceasedDate),
            ['lastName', 'firstName'],
            ['asc', 'asc']
        );
        // this.executiveAdmin = this.auth.hasRole('Executive:Admin');
        // this.reviewOnly = !this.auth.hasRole('Executive:Clerk');
        await this.getData();
    }

    async getData() {
        this.appInfo.pleaseWaitShow();
        const auctionPaddleInfos = await this.uow.getAuctionPaddles();
        auctionPaddleInfos.forEach((paddle) => {
            paddle.displayName = `Paddle ${paddle.paddleNumber} --- ${paddle.assignedTo}`;
        });
        this.auctionPaddleInfos = auctionPaddleInfos;
        this.auctionPurchases = (await this.uow.auctionPurchases.whereActive(null, 'auctionItem, auctionPaddleUser.auctionPaddle')) as AuctionPurchase[];
        this.auctionItems = await this.uow.getAuctionItems();
        this.appInfo.pleaseWaitHide();
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                template: 'toolbarText',
                location: 'before',
            },
            {
                location: 'before',
                template: 'toolbarButtons',
            }
        );
    }

    rowPrepare(e) {
        // if (e.rowType === 'data') {
        //     if (!!e.data.approved) {
        //         e.rowElement.className = e.rowElement.className + ' approved';
        //     }
        //     if (!!e.data.declined) {
        //         e.rowElement.className = e.rowElement.className + ' declined';
        //     }
        //     if (!e.data.approved && !e.data.declined) {
        //         e.rowElement.className = e.rowElement.className + ' waiting-for-vote';
        //     }
        // }
    }
    rowDoubleClick(e) {
        this.add(e.data);
    }
    async add(selectedRow?: any) {
        const modalRef = this.modalService.show(AuctionPurchaseDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                auctionItems: this.auctionItems,
                auctionPaddleInfos: this.auctionPaddleInfos,
                purchase: selectedRow ? selectedRow : null,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
                await this.getData();
            }
            modalRef.hide();
        });
    }

    async delete(selectedRow: any) {
        const result = await confirm('Are you sure you want to delete this Purchase?', this.appInfo.settings.church.toUpperCase());
        if (!result) return;
        this.appInfo.pleaseWaitShow();

        selectedRow.deleted = new Date();
        selectedRow.deletedBy = this.auth.currentUser.userName;
        await this.uow.commit();
        await this.getData();

        this.appInfo.pleaseWaitHide();
    }

    async print() {
        // const selectedRow = this.dataGrid.instance.getSelectedRowsData()[0];
        // if (!selectedRow) return;
        // await this.utility.printProposal(selectedRow.id);
    }
}
